import ProtectedPage from "../../../common/ProtectedPage";
import ClientHeader from "../../../common/ClientHeader";
import "./ContactPageStyles.css";

export default function ContactPage({ currentCommand, setCurrentCommand }) {

    return (
        <ProtectedPage key={`contact-${currentCommand?.id}`} permissionsNeeded="client" needToBeAuthenticated={false} redirectPath="/client-auth">
            <ClientHeader displayCart={false} currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />
            <div className="contact-container">
                <div className="contact-content">
                    <div className="contact-header">
                        <h1 className="contact-title">Contact Us</h1>
                        <p className="contact-subtitle">
                            Have a question or special request? Feel free to contact us. 
                            Our team is here to help you.
                        </p>
                    </div>

                    <div className="contact-cards-grid">
                        <div className="contact-card">
                            <div className="contact-icon">📧</div>
                            <h2 className="contact-card-title">Email</h2>
                            <p className="contact-card-content">
                                Send us an email and we will reply as soon as possible.
                            </p>
                            <a href="mailto:contact@patricians.xyz" className="contact-link">
                                contact@patricians.xyz
                            </a>
                        </div>

                        <div className="contact-card">
                            <div className="contact-icon">📞</div>
                            <h2 className="contact-card-title">Phone</h2>
                            <p className="contact-card-content">
                                Call us directly for immediate contact with our team.
                            </p>
                            <a href="tel:+32471790496" className="contact-link">
                                +32 471 79 04 96
                            </a>
                        </div>

                        <div className="contact-card">
                            <div className="contact-icon">📍</div>
                            <h2 className="contact-card-title">Address</h2>
                            <p className="contact-card-content">
                                Visit us at our premises for in-person service.
                            </p>
                            <div className="contact-card-content" style={{ marginTop: "10px", fontWeight: "500" }}>
                                123 Rue de la République<br />
                                75001 Paris, France
                            </div>
                        </div>
                    </div>

                    <div className="opening-hours">
                        <div className="opening-hours-header">
                            <div className="opening-hours-icon">🕐</div>
                            <h2 className="opening-hours-title">Opening Hours</h2>
                            <p className="opening-hours-subtitle">Visit us during the following hours</p>
                        </div>
                        <div className="hours-grid">
                            <div className="hour-item">
                                <div className="hour-day">Monday</div>
                                <div className="hour-time">9:00 AM - 6:00 PM</div>
                            </div>
                            <div className="hour-item">
                                <div className="hour-day">Tuesday</div>
                                <div className="hour-time">9:00 AM - 6:00 PM</div>
                            </div>
                            <div className="hour-item">
                                <div className="hour-day">Wednesday</div>
                                <div className="hour-time">9:00 AM - 6:00 PM</div>
                            </div>
                            <div className="hour-item">
                                <div className="hour-day">Thursday</div>
                                <div className="hour-time">9:00 AM - 6:00 PM</div>
                            </div>
                            <div className="hour-item">
                                <div className="hour-day">Friday</div>
                                <div className="hour-time">9:00 AM - 6:00 PM</div>
                            </div>
                            <div className="hour-item">
                                <div className="hour-day">Saturday</div>
                                <div className="hour-time">9:00 AM - 12:00 PM</div>
                            </div>
                            <div className="hour-item">
                                <div className="hour-day">Sunday</div>
                                <div className="hour-time closed">Closed</div>
                            </div>
                        </div>
                    </div>

                    <div className="social-section">
                        <h2 className="social-title">Follow us</h2>
                        <div className="social-links">
                            <a href="#" className="social-link" aria-label="Facebook">📘</a>
                            <a href="#" className="social-link" aria-label="Instagram">📷</a>
                            <a href="#" className="social-link" aria-label="LinkedIn">💼</a>
                            <a href="#" className="social-link" aria-label="Twitter">🐦</a>
                        </div>
                    </div>

                    <div className="map-section">
                        <div className="map-placeholder">
                            📍 Google Maps - 123 Rue de la République, 75001 Paris
                        </div>
                    </div>
                </div>
            </div>
        </ProtectedPage>
    );
}